import React from 'react';
import { Routes } from 'react-router-dom';

import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Feature } from '@occc/utils-access-control';
import { SentryRoute as Route } from '@occc-app/App/sentry';

import RewardUpdatePage from './RewardUpdatePage';
import RewardCreatePage from './RewardCreatePage';
import RewardConfigurePage from './RewardConfigurePage';

const Reward: React.FC = () => (
  <Routes>
    <Route
      path='create'
      element={
        <ProtectedRoute feature={Feature.CAMPAIGN_COMPONENT_CREATE}>
          <RewardCreatePage />
        </ProtectedRoute>
      }
    />
    <Route path=':rewardId/configure/*' element={<RewardConfigurePage />} />
    <Route path=':rewardId/update/*' element={<RewardUpdatePage />} />
  </Routes>
);

export default Reward;
